import React from "react";
import Message from "assets/scripts/components/common/Message/Message";
import classNames from "classnames";
const ErrorBlock = ({ id, error, className, ...otherProps }) => (<span id={id || undefined} className={classNames("help-block error-block", className)} {...otherProps}>
		<Message value={error}/>
	</span>);
export default ErrorBlock;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/FormGroup/ErrorBlock.tsx